import React from 'react';
import styled from 'styled-components';

import { Container, Typography } from '@material-ui/core/';

import CardWrapper from '../components/common/CardWrapper';
import FormEditAccount from '../components/forms/FormEditAccount';
import FormChangePassword from '../components/forms/FormChangePassword';

const Root = styled(Container)`
	h1 {
		font-size: 24px;
		font-weight: bold;
	}
`;

const PageProfile = () => (
	<Root maxWidth="lg">
		<CardWrapper>
			<Typography variant="h1">Mein Account</Typography>
		</CardWrapper>
		<CardWrapper>
			<FormEditAccount />
		</CardWrapper>
		<CardWrapper>
			<FormChangePassword />
		</CardWrapper>
	</Root>
);

export default PageProfile;
